import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  faSortAmountDown,
  faSortAmountDownAlt,
} from '@fortawesome/pro-solid-svg-icons';

import { useQueryParams } from '@app/hooks';
import { generateRouteParams } from '@app/utils';
import { sortByItemsMessages } from '@app/translations';
import { SORT_DIRECTION, SortOption } from '@app/constants';

interface SortUtils {
  sortDirection: SORT_DIRECTION;
  sortOptions: SortOption[];
  shouldBeReversed: boolean;
  handleSortChange: (option: SortOption) => void;
  getSortedList: <T>(list: T) => T;
}

export const useDashboardListSorting = (): SortUtils => {
  const { sortDirection: sortDirectionUrl } = useQueryParams();
  const [sortDirection, setSortDirection] = useState(
    (sortDirectionUrl as SORT_DIRECTION) ?? SORT_DIRECTION.desc
  );
  const navigate = useNavigate();
  const location = useLocation();
  const shouldBeReversed = sortDirection === 'ascending';

  const handleSortChange = option => {
    setSortDirection(option.sortDirection);

    navigate(
      generateRouteParams({
        pathname: location.pathname,
        query: {
          sortDirection: option.sortDirection,
        },
      })
    );
  };

  const getSortedList = list => (shouldBeReversed ? [...list].reverse() : list);

  const sortOptions = [
    {
      label: sortByItemsMessages.project,
      sortField: 'name',
      sortDirection: SORT_DIRECTION.desc,
      icon: faSortAmountDown,
    },
    {
      label: sortByItemsMessages.project,
      sortField: 'name',
      sortDirection: SORT_DIRECTION.asc,
      icon: faSortAmountDownAlt,
    },
  ];

  return {
    sortDirection,
    sortOptions,
    shouldBeReversed,
    handleSortChange,
    getSortedList,
  };
};
